import { difference, intersection, range } from "lodash";
import React, { ElementType, Fragment } from "react";
import { formatAggregatedSteps, formatBaseTime } from "../../../../utils/Format";

const CYCLE_49r1_UPDATE_DATE = new Date('2024-11-12T00:00:00Z');

const BC_TIMES = [6, 18];
const BC_STEPS_06_18 = (timestamp?: string) => {
  const date = timestamp ? new Date(timestamp) : new Date();

  return new Set([
    ...range(0, 91),
    ...(CYCLE_49r1_UPDATE_DATE.getTime() < date.getTime() ? range(93, 147, 3) : [])
  ]);
}
const BC_STEPS_06_18_ENS = BC_STEPS_06_18;

const BcSteps = (props: {
  steps: Array<number>;
  times: Array<number>;
  type: 'hres' | 'ens';
  as: ElementType;
  timestamp?: string;
}) => {
  const { times, steps, type, as } = props;
  const Component = as;

  const runTimes_00_12 = difference(times, BC_TIMES);
  const runTimes_06_18 = intersection(times, BC_TIMES);

  const label_00_12 = runTimes_00_12.length ?
    runTimes_00_12.map(formatBaseTime) :
    runTimes_06_18.map(t => formatBaseTime(t - 6));

  const label_06_18 = runTimes_06_18.map(formatBaseTime);

  const values_00_12 = formatAggregatedSteps(runTimes_00_12.length ? steps : []);
  const values_06_18 = formatAggregatedSteps(steps.filter(v => (type === 'hres' ? BC_STEPS_06_18() : BC_STEPS_06_18_ENS()).has(v)))

  return (
    <Fragment>
      <Component>
        [{label_00_12.join(', ')}]: {values_00_12}
      </Component>

      {
        Boolean(runTimes_06_18.length) &&
        <Component>
          [{label_06_18.join(', ')}]: {values_06_18}
        </Component>
      }
    </Fragment>
  )
}

export default BcSteps;
